import React from 'react';

/**
 * Enlace de pestaña para los resúmenes de ficha.
 *
 * Es un `span` con role=button (no un `<button>`) porque el `<fieldset>` de la
 * ficha se deshabilita en modo lectura y desactivaría los botones. Los enlaces
 * y los spans sí siguen funcionando dentro de un fieldset disabled.
 */
export default function ContextTabLink({ tab, onSelect, children }) {
  return (
    <span
      role="button"
      tabIndex={0}
      className="dv-context-link"
      onClick={() => onSelect(tab)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect(tab);
        }
      }}
    >
      {children}
    </span>
  );
}
